"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPTIMIZELY_TEST_NAMES = {
    TEST_DRIVE_DEEP_LINK_TEST: 'TestDriveDeepLinkTest',
    VDP_SECOND_CTA: 'VDP_SECOND_CTA',
    PERSISTENT_SEND_CTA: 'PersistentSendCTA',
    LEAD_FORM_VDP: 'LeadFormModalOnVDP',
    LEAD_FORM_CTA: 'LeadFormCta',
    ONBOARDING_VDP_ATC_MOBILE: 'ONBOARDING_VDP_ATC_MOBILE',
    SOCIAL_OAUTH_LEAD_FORM_ATC_KBB: 'SOCIAL_OAUTH_LEAD_FORM_ATC_KBB',
    SOCIAL_OAUTH_LEAD_FORM_DDC: 'SOCIAL_OAUTH_LEAD_FORM_DDC',
    VDP_REDESIGN_CONTROLS_DEALER: 'VDP_REDESIGN_CONTROLS_DEALER',
    VDP_REDESIGN_CONTROLS_CLASSIFIED: 'VDP_REDESIGN_CONTROLS_CLASSIFIED',
    VDP_LEAD_CLASSIFIED_KBB_ATC: 'VDP_LEAD_CLASSIFIED_KBB_ATC',
    VDP_LEAD_DEALER_DDC_OPT_IN: 'VDP_LEAD_DEALER_DDC_OPT_IN',
    PAYMENT_REDESIGN_RETEST_ATC_KBB: 'PAYMENT_REDESIGN_RETEST_ATC_KBB',
    PAYMENT_REDESIGN_RETEST_DDC: 'PAYMENT_REDESIGN_RETEST_DDC',
    DEBUG_ADOBE_1: 'DEBUG_ADOBE_1',
    DEBUG_ADOBE_2: 'DEBUG_ADOBE_2',
    DEBUG_ADOBE_3: 'DEBUG_ADOBE_3',
    SDP_PANEL_CTA_DEALER: 'SDP_PANEL_CTA_DEALER',
    SDP_PANEL_CTA_CLASSIFIED: 'SDP_PANEL_CTA_CLASSIFIED',
    SIDE_BY_SIDE_PRICING_DEALER: 'SIDE_BY_SIDE_PRICING_DEALER',
    SIDE_BY_SIDE_PRICING_CLASSIFIED: 'SIDE_BY_SIDE_PRICING_CLASSIFIED',
    TRADEIN_SINGLE_COLUMN_DDC: 'TRADEIN_SINGLE_COLUMN_DDC',
    TRADEIN_SINGLE_COLUMN_ATC_KBB: 'TRADEIN_SINGLE_COLUMN_ATC_KBB',
    SHOPPER_ONBOARDING_ON_VDP_DDC: 'SHOPPER_ONBOARDING_ON_VDP_DDC',
    SHOPPER_ONBOARDING_ON_VDP_CLASSIFIED: 'SHOPPER_ONBOARDING_ON_VDP_CLASSIFIED',
    SDP_LANDING_INTERSTITIAL_DEALER: 'SDP_LANDING_INTERSTITIAL_DEALER',
    SDP_LANDING_INTERSTITIAL_CLASSIFIED: 'SDP_LANDING_INTERSTITIAL_CLASSIFIED',
    SDP_LANDING_INTERSTITIAL_TEXT_DEALER: 'SDP_LANDING_INTERSTITIAL_TEXT_DEALER',
    SDP_LANDING_INTERSTITIAL_TEXT_CLASSIFIED: 'SDP_LANDING_INTERSTITIAL_TEXT_CLASSIFIED',
    TRADE_IN_NEXT_STEPS_DEALER: 'TRADE_IN_NEXT_STEPS_DEALER',
    TRADE_IN_NEXT_STEPS_CLASSIFIED: 'TRADE_IN_NEXT_STEPS_CLASSIFIED',
    MONTHLY_PAYMENT_RANGE_DEALER: 'MONTHLY_PAYMENT_RANGE_DEALER',
    MONTHLY_PAYMENT_RANGE_CLASSIFIED: 'MONTHLY_PAYMENT_RANGE_CLASSIFIED',
    DEAL_SUMMARY_LEAD_FORM_DEALER: 'DEAL_SUMMARY_LEAD_FORM_DEALER',
    DEAL_SUMMARY_LEAD_FORM_CLASSIFIED: 'DEAL_SUMMARY_LEAD_FORM_CLASSIFIED',
    SDP_LANDING_RECOMMENDED_STEP_DEALER: 'SDP_LANDING_RECOMMENDED_STEP_DEALER',
    SDP_LANDING_RECOMMENDED_STEP_CLASSIFIED: 'SDP_LANDING_RECOMMENDED_STEP_CLASSIFIED',
    SDP_MOBILE_MODAL_DEALER: 'SDP_MOBILE_MODAL_DEALER',
    TRADEIN_LEADFORM_SINGLE_COLUMN_DDC: 'TRADEIN_LEADFORM_SINGLE_COLUMN_DDC',
    TRADEIN_LEADFORM_SINGLE_COLUMN_ATC_KBB: 'TRADEIN_LEADFORM_SINGLE_COLUMN_ATC_KBB',
    SP_VEHICLE_PROTECTION: 'vehicle_protection_a_b_test',
    SP_SELECT_INCENTIVES: 'SP_SELECT_INCENTIVES'
};
/**
 * DEBUG_ADOBE_1 & DEBUG_ADOBE_2 & DEBUG_ADOBE_3 are
 * tests that do not manipulate the application in any way.
 * They are here and need to be released to Prod for analytics testing
 * */
exports.experiments = [
    {
        experimentId: '16729681121',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.DEBUG_ADOBE_1,
        testVariations: [
            {
                id: '16721852152',
                name: 'control'
            },
            {
                id: '16731640998',
                name: 'variation'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16741690107',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.DEBUG_ADOBE_2,
        testVariations: [
            {
                id: '16716210807',
                name: 'control'
            },
            {
                id: '16712800034',
                name: 'variation'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16733720473',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.DEBUG_ADOBE_3,
        testVariations: [
            {
                id: '16720380516',
                name: 'control'
            },
            {
                id: '16732030429',
                name: 'variation'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '15102570165',
        testName: exports.OPTIMIZELY_TEST_NAMES.PERSISTENT_SEND_CTA,
        team: 'GearShift',
        testVariations: [
            {
                id: '15120960158',
                name: 'PERSISTENT_SEND'
            },
            {
                id: '15092630365',
                name: 'VIEW_BREAKDOWN'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '14952760990',
        team: 'GearShift',
        testName: exports.OPTIMIZELY_TEST_NAMES.VDP_SECOND_CTA,
        testVariations: [
            {
                id: '14954760348',
                name: 'ONE_CTA_CONTROL'
            },
            {
                id: '14983550078',
                name: 'ONE_CTA_MODAL'
            },
            {
                id: '14983530230',
                name: 'TWO_CTA_MODAL'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '14330410062',
        team: 'GearShift',
        testName: exports.OPTIMIZELY_TEST_NAMES.LEAD_FORM_CTA,
        testVariations: [
            {
                id: '14326120279',
                name: 'noLead'
            },
            {
                id: '14310290465',
                name: 'leadOnly'
            },
            {
                id: '14336060500',
                name: 'leadFocused'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '14180660612',
        team: 'Torque',
        testName: exports.OPTIMIZELY_TEST_NAMES.TEST_DRIVE_DEEP_LINK_TEST,
        testVariations: [
            {
                id: '14201000173',
                name: 'TestDriveBtnHidden'
            },
            {
                id: '14174910339',
                name: 'TestDriveBtnShown'
            }
        ],
        activateOnDemand: false
    },
    /* TODO
    * This test is currently archived and will not allow anyone to see its ID's
    * Please add IDs when LEAD_FORM_VDP test goes back on to support adobe integration
    */
    {
        experimentId: '',
        team: 'Torque',
        testName: exports.OPTIMIZELY_TEST_NAMES.LEAD_FORM_VDP,
        testVariations: [
            {
                id: '',
                name: 'noLeadForm'
            },
            {
                id: '',
                name: 'leadFormPersonalizeSubmitGuest'
            },
            {
                id: '',
                name: 'leadFormPersonalizeSubmitNoThanks'
            },
            {
                id: '',
                name: 'leadFormPersonalizeSendGuest'
            },
            {
                id: '',
                name: 'leadFormPersonalizeSendNoThanks'
            },
            {
                id: '',
                name: 'leadFormContinueSubmitGuest'
            },
            {
                id: '',
                name: 'leadFormContinueSubmitNoThanks'
            },
            {
                id: '',
                name: 'leadFormContinueSendGuest'
            },
            {
                id: '',
                name: 'leadFormContinueSendNoThanks'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '15604120664',
        team: 'Torque',
        testName: exports.OPTIMIZELY_TEST_NAMES.ONBOARDING_VDP_ATC_MOBILE,
        testVariations: [
            {
                id: '15586760609',
                name: 'ONBOARDING_SHOWN'
            },
            {
                id: '15619881104',
                name: 'ONBOARDING_HIDDEN'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '15841570642',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.SOCIAL_OAUTH_LEAD_FORM_ATC_KBB,
        testVariations: [
            {
                id: '15827760243',
                name: 'social_control'
            },
            {
                id: '15839430405',
                name: 'social_visible'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16000920376',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.SOCIAL_OAUTH_LEAD_FORM_DDC,
        testVariations: [
            {
                id: '16055020161',
                name: 'social_control'
            },
            {
                id: '16027830105',
                name: 'social_visible'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '15926861568',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.VDP_REDESIGN_CONTROLS_DEALER,
        testVariations: [
            {
                id: '15955480207',
                name: 'EXISTING_CONTROLS'
            },
            {
                id: '15936760693',
                name: 'NEW_CONTROLS'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '15961180511',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.VDP_REDESIGN_CONTROLS_CLASSIFIED,
        testVariations: [
            {
                id: '15973250027',
                name: 'EXISTING_CONTROLS'
            },
            {
                id: '15971110378',
                name: 'NEW_CONTROLS'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16273030414',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.VDP_LEAD_CLASSIFIED_KBB_ATC,
        testVariations: [
            {
                id: '16236740657',
                name: 'NO_LEAD_FORM_SINGLE_CTA'
            },
            {
                id: '16242750225',
                name: 'VDP_LEAD_FORM_TWO_CTA'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16248330228',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.VDP_LEAD_DEALER_DDC_OPT_IN,
        testVariations: [
            {
                id: '16265390107',
                name: 'NO_LEAD_FORM_SINGLE_CTA'
            },
            {
                id: '16258380030',
                name: 'VDP_LEAD_FORM_TWO_CTA'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16462310294',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.PAYMENT_REDESIGN_RETEST_ATC_KBB,
        testVariations: [
            {
                id: '16448610241',
                name: 'control'
            },
            {
                id: '16452410220',
                name: 'NewPaymentTerms'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16462310294',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.PAYMENT_REDESIGN_RETEST_DDC,
        testVariations: [
            {
                id: '16448610269',
                name: 'control'
            },
            {
                id: '16465900418',
                name: 'NewPaymentTerms'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16849580365',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SDP_PANEL_CTA_DEALER,
        testVariations: [
            {
                id: '16845970168',
                name: 'PANELS_HIDDEN'
            },
            {
                id: '16865913956',
                name: 'PANELS_SHOW_TRADEIN_CTA'
            },
            {
                id: '16834605499',
                name: 'PANELS_SHOW_TESTDRIVE_CTA'
            },
            {
                id: '16865385378',
                name: 'PANELS_SHOW_CREDITAPP_CTA'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16841290329',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SDP_PANEL_CTA_CLASSIFIED,
        testVariations: [
            {
                id: '16835800080',
                name: 'PANELS_HIDDEN'
            },
            {
                id: '16865196149',
                name: 'PANELS_SHOW_TRADEIN_CTA'
            },
            {
                id: '16888940499',
                name: 'PANELS_SHOW_TESTDRIVE_CTA'
            },
            {
                id: '16860116995',
                name: 'PANELS_SHOW_CREDITAPP_CTA'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16842460620',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SIDE_BY_SIDE_PRICING_DEALER,
        testVariations: [
            {
                id: '16844772043',
                name: 'TAB_PRICING'
            },
            {
                id: '16856151809',
                name: 'SIDE_BY_SIDE_PRICING'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16854261371',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SIDE_BY_SIDE_PRICING_CLASSIFIED,
        testVariations: [
            {
                id: '16832631349',
                name: 'TAB_PRICING'
            },
            {
                id: '16863831957',
                name: 'SIDE_BY_SIDE_PRICING'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16868620715',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.TRADEIN_SINGLE_COLUMN_DDC,
        testVariations: [
            {
                id: '16864532316',
                name: 'CONTROL'
            },
            {
                id: '16868311312',
                name: 'SINGLE_COL'
            }
        ],
        activateOnDemand: true
    },
    {
        experimentId: '16885585808',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.TRADEIN_SINGLE_COLUMN_ATC_KBB,
        testVariations: [
            {
                id: '16890152211',
                name: 'CONTROL'
            },
            {
                id: '16868212383',
                name: 'SINGLE_COL'
            }
        ],
        activateOnDemand: true
    },
    {
        experimentId: '16920181100',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SHOPPER_ONBOARDING_ON_VDP_DDC,
        testVariations: [
            {
                id: '16904353497',
                name: 'SHOPPER_ONBOARDING_VISIBLE'
            },
            {
                id: '16909581981',
                name: 'SHOPPER_ONBOARDING_HIDDEN'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16923174797',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SHOPPER_ONBOARDING_ON_VDP_CLASSIFIED,
        testVariations: [
            {
                id: '16915523151',
                name: 'SHOPPER_ONBOARDING_VISIBLE'
            },
            {
                id: '16933333706',
                name: 'SHOPPER_ONBOARDING_HIDDEN'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16912830301',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SDP_LANDING_INTERSTITIAL_DEALER,
        testVariations: [
            {
                id: '16908493520',
                name: 'NO_INTERSTITIAL'
            },
            {
                id: '16920192109',
                name: 'LANDING_INTERSTITIAL'
            }
        ],
        activateOnDemand: true
    },
    {
        experimentId: '16908613285',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SDP_LANDING_INTERSTITIAL_CLASSIFIED,
        testVariations: [
            {
                id: '16914213092',
                name: 'NO_INTERSTITIAL'
            },
            {
                id: '16941045167',
                name: 'LANDING_INTERSTITIAL'
            }
        ],
        activateOnDemand: true
    },
    {
        experimentId: '17281043246',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SDP_LANDING_INTERSTITIAL_TEXT_DEALER,
        testVariations: [
            {
                id: '17268193887',
                name: 'ORIGINAL'
            },
            {
                id: '17262463878',
                name: 'VARIATION1'
            },
            {
                id: '17283611975',
                name: 'VARIATION2'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '17258754630',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SDP_LANDING_INTERSTITIAL_TEXT_CLASSIFIED,
        testVariations: [
            {
                id: '17291142864',
                name: 'ORIGINAL'
            },
            {
                id: '17289102702',
                name: 'VARIATION1'
            },
            {
                id: '17266313801',
                name: 'VARIATION2'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '16946790944',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.TRADE_IN_NEXT_STEPS_DEALER,
        testVariations: [
            {
                id: '16986580091',
                name: 'NO_NEXT_STEPS'
            },
            {
                id: '16948230828',
                name: 'SHOW_NEXT_STEPS'
            }
        ],
        activateOnDemand: true
    },
    {
        experimentId: '17020950137',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.TRADE_IN_NEXT_STEPS_CLASSIFIED,
        testVariations: [
            {
                id: '16971860700',
                name: 'NO_NEXT_STEPS'
            },
            {
                id: '16975440707',
                name: 'SHOW_NEXT_STEPS'
            }
        ],
        activateOnDemand: true
    },
    {
        experimentId: '17091980053',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.MONTHLY_PAYMENT_RANGE_DEALER,
        testVariations: [
            {
                id: '17024252533',
                name: 'CONTROL'
            },
            {
                id: '17088040536',
                name: 'DOLLARS'
            },
            {
                id: '17010893441',
                name: 'PERCENT_ROUNDED'
            },
            {
                id: '17061471511',
                name: 'PERCENT_UNROUNDED'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '17043144533',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.MONTHLY_PAYMENT_RANGE_CLASSIFIED,
        testVariations: [
            {
                id: '17008423709',
                name: 'CONTROL'
            },
            {
                id: '17031523044',
                name: 'DOLLARS'
            },
            {
                id: '17024881388',
                name: 'PERCENT_ROUNDED'
            },
            {
                id: '17040983582',
                name: 'PERCENT_UNROUNDED'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '17022392195',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.DEAL_SUMMARY_LEAD_FORM_DEALER,
        testVariations: [
            {
                id: '17020221527',
                name: 'CONTROL'
            },
            {
                id: '17086400290',
                name: 'REFINED_LEAD_FORM'
            }
        ],
        activateOnDemand: true
    },
    {
        experimentId: '17103570060',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.DEAL_SUMMARY_LEAD_FORM_CLASSIFIED,
        testVariations: [
            {
                id: '17063881297',
                name: 'CONTROL'
            },
            {
                id: '17021652143',
                name: 'REFINED_LEAD_FORM'
            }
        ],
        activateOnDemand: true
    },
    {
        experimentId: '17223340172',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SDP_LANDING_RECOMMENDED_STEP_DEALER,
        testVariations: [
            {
                id: '17202400319',
                name: 'NO_INTERSTITIAL'
            },
            {
                id: '17208050138',
                name: 'LANDING_INTERSTITIAL'
            },
            {
                id: '17192610212',
                name: 'LANDING_INTERSTITIAL_RECOMMENDED_STEP'
            }
        ],
        activateOnDemand: true
    },
    {
        experimentId: '17210050229',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SDP_LANDING_RECOMMENDED_STEP_CLASSIFIED,
        testVariations: [
            {
                id: '17194780128',
                name: 'NO_INTERSTITIAL'
            },
            {
                id: '17224990154',
                name: 'LANDING_INTERSTITIAL'
            },
            {
                id: '17221230258',
                name: 'LANDING_INTERSTITIAL_RECOMMENDED_STEP'
            }
        ],
        activateOnDemand: true
    },
    {
        experimentId: '17519651009',
        team: 'TORQUE',
        testName: exports.OPTIMIZELY_TEST_NAMES.SDP_MOBILE_MODAL_DEALER,
        testVariations: [
            {
                id: '17518251025',
                name: 'CONTROL'
            },
            {
                id: '17539881326',
                name: 'MOBILE_MODAL'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '17613310470',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.TRADEIN_LEADFORM_SINGLE_COLUMN_DDC,
        testVariations: [
            {
                id: '17597190394',
                name: 'CONTROL'
            },
            {
                id: '17595670362',
                name: 'SINGLE_COLUMN_LEAD_FORM'
            }
        ],
        activateOnDemand: true
    },
    {
        experimentId: '17580720135',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.TRADEIN_LEADFORM_SINGLE_COLUMN_ATC_KBB,
        testVariations: [
            {
                id: '17601350433',
                name: 'CONTROL'
            },
            {
                id: '17603600142',
                name: 'SINGLE_COLUMN_LEAD_FORM'
            }
        ],
        activateOnDemand: true
    },
    {
        experimentId: '20205420177',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.SP_VEHICLE_PROTECTION,
        testVariations: [
            {
                id: '20203573602',
                name: 'Control'
            },
            {
                id: '20182625485',
                name: 'VPP_Primary_Workflow'
            },
            {
                id: '20180923798',
                name: 'VPP_Upsell_Confirmation'
            }
        ],
        activateOnDemand: false
    },
    {
        experimentId: '20211361977',
        team: 'GEARSHIFT',
        testName: exports.OPTIMIZELY_TEST_NAMES.SP_SELECT_INCENTIVES,
        testVariations: [
            {
                id: '20205421780',
                name: 'CONTROL'
            },
            {
                id: '20197716067',
                name: 'SELECT_INCENTIVES_BEFORE_TRADE_IN'
            },
            {
                id: '20209249876',
                name: 'SELECT_INCENTIVES_AFTER_TRADE_IN'
            }
        ],
        activateOnDemand: false
    }
];
